
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { ModuleItemProps } from ".";
import { loading, update } from "store/module";
import { AppMessage } from "components";

interface ApiModuleUpdateInputProps extends ModuleItemProps {
}

type ApiModuleUpdateOutputProps = OutputBaseProps<{ item: ModuleItemProps; }, ApiModuleUpdateInputProps>

export const apiModuleUpdate = async (data: ApiModuleUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiModuleUpdateOutputProps>("/api/module/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};